<template>
  <v-container fluid>
    <v-card class="mb-4" flat>
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedMonth"
              :items="months"
              label="Chọn Tháng"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="selectedYear"
              :items="years"
              label="Chọn Năm"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary" @click="fetchData" :loading="loading">
              <v-icon left>mdi-magnify</v-icon> Tạo báo cáo
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat>
      <v-card-title>
        Báo cáo Doanh Thu Sale - Hàng Chính Ngạch
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
      </v-card-title>
      
      <!-- Summary boxes -->
      <v-row class="px-4 pb-4">
          <v-col cols="12" md="3">
             <v-card color="blue lighten-5">
                 <v-card-text class="text-center">
                     <div class="subtitle-1">Số Đơn Hoàn Thành / Đang Giao</div>
                     <div class="text-h5 font-weight-bold">{{ sumTotal.CompletedOrders }} / {{ sumTotal.DeliveringOrders }}</div>
                 </v-card-text>
             </v-card>
          </v-col>
          <v-col cols="12" md="3">
             <v-card color="green lighten-5">
                 <v-card-text class="text-center">
                     <div class="subtitle-1">Doanh Thu Ghi Nhận</div>
                     <div class="text-h5 font-weight-bold">{{ sumTotal.TotalRevenue | currency('VND', 0, 'đ', 'vi-VN') }}</div>
                 </v-card-text>
             </v-card>
          </v-col>
          <v-col cols="12" md="3">
             <v-card color="red lighten-5">
                 <v-card-text class="text-center">
                     <div class="subtitle-1">Chi Phí</div>
                     <div class="text-h5 font-weight-bold">{{ sumTotal.TotalCost | currency('VND', 0, 'đ', 'vi-VN') }}</div>
                 </v-card-text>
             </v-card>
          </v-col>
          <v-col cols="12" md="3">
             <v-card color="purple lighten-5">
                 <v-card-text class="text-center">
                     <div class="subtitle-1">Lợi Nhuận Gộp</div>
                     <div class="text-h5 font-weight-bold">{{ sumTotal.TotalProfit | currency('VND', 0, 'đ', 'vi-VN') }}</div>
                 </v-card-text>
             </v-card>
          </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        class="elevation-1 table-bordered"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.SaleName="{ item }">
          <strong>{{ item.SaleName }}</strong>
        </template>
        <template v-slot:item.TotalRevenue="{ item }">
          <span class="green--text font-weight-medium">{{ item.TotalRevenue | currency('VND', 0, 'đ', 'vi-VN') }}</span>
        </template>
        <template v-slot:item.TotalCost="{ item }">
          <span class="red--text font-weight-medium">{{ item.TotalCost | currency('VND', 0, 'đ', 'vi-VN') }}</span>
        </template>
        <template v-slot:item.TotalProfit="{ item }">
          <span class="purple--text font-weight-bold">{{ item.TotalProfit | currency('VND', 0, 'đ', 'vi-VN') }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  name: 'CnSalesDashboard',
  data() {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth() + 1
    
    return {
      selectedMonth: currentMonth,
      selectedYear: currentYear,
      months: Array.from({ length: 12 }, (_, i) => i + 1),
      years: Array.from({ length: Math.max(0, currentYear - 2021) + 3 }, (_, i) => 2022 + i).reverse(),
      loading: false,
      items: [],
      headers: [
        { text: 'Tên Sale', value: 'SaleName', align: 'start' },
        { text: 'Đơn hoàn thành', value: 'CompletedOrders', align: 'right' },
        { text: 'Đang giao (chưa TT)', value: 'DeliveringOrders', align: 'right' },
        { text: 'Tổng doanh thu', value: 'TotalRevenue', align: 'right' },
        { text: 'Tổng chi phí', value: 'TotalCost', align: 'right' },
        { text: 'Lợi nhuận gộp', value: 'TotalProfit', align: 'right' }
      ]
    }
  },
  computed: {
     sumTotal() {
         let stats = {
             CompletedOrders: 0,
             DeliveringOrders: 0,
             TotalRevenue: 0,
             TotalCost: 0,
             TotalProfit: 0
         }
         this.items.forEach(it => {
             stats.CompletedOrders += parseFloat(it.CompletedOrders || 0)
             stats.DeliveringOrders += parseFloat(it.DeliveringOrders || 0)
             stats.TotalRevenue += parseFloat(it.TotalRevenue || 0)
             stats.TotalCost += parseFloat(it.TotalCost || 0)
             stats.TotalProfit += parseFloat(it.TotalProfit || 0)
         })
         return stats
     }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await ApiService.query('/api/report/cn-sales-dashboard/', {
          month: this.selectedMonth,
          year: this.selectedYear
        })
        this.items = response.data.data
      } catch (error) {
        console.error(error)
        this.$toast.error('Có lỗi xảy ra khi lấy dữ liệu báo cáo')
      } finally {
        this.loading = false
      }
    },
    exportExcel() {
       // Simple CSV export for now
       if (!this.items.length) return;
       let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
       csvContent += "Tên Sale,Đơn hoàn thành,Đang giao,Tổng doanh thu,Tổng chi phí,Lợi nhuận\n";
       
       this.items.forEach(row => {
           csvContent += `${row.SaleName},${row.CompletedOrders},${row.DeliveringOrders},${row.TotalRevenue},${row.TotalCost},${row.TotalProfit}\n`;
       });
       
       const encodedUri = encodeURI(csvContent);
       const link = document.createElement("a");
       link.setAttribute("href", encodedUri);
       link.setAttribute("download", `Bao_Cao_Sale_CN_${this.selectedMonth}_${this.selectedYear}.csv`);
       document.body.appendChild(link);
       link.click();
       document.body.removeChild(link);
    }
  }
}
</script>

<style scoped>
.table-bordered ::v-deep th {
  border: 1px solid #eeeeee !important;
  background-color: #f5f5f5;
}
.table-bordered ::v-deep td {
  border: 1px solid #eeeeee !important;
}
</style>
